<template>
  <div class="ticker">
    <div class="tb-checkbox">
      <input type="checkbox" id="interactiveBox" v-on:change="setField('interactive', $event.target.checked)" :checked="getField('interactive')" data-test="displays-editors-showCTA">
      <label class="checkbox" for="interactiveBox">Interactive</label>
    </div>

    <cta
      :item="item"
      :theme="theme"
      :editing="editing"
    />

    <animation
      v-model="animation"
      :options="animationOptions"
    />

    <div class="tb-form-group">
      <label class="tb-label">Crawl speed</label>

      <select
        class="tb-select"
        data-entity="producer-editor-scrollSpeed"
        data-test="display-editor-scrollSpeed"
        @change="setField('scrollSpeed', $event.target.value)"
      >
        <option :selected="getField('scrollSpeed') === '3000'" value="3000">Slow</option>
        <option :selected="getField('scrollSpeed') === '2000'" value="2000">Normal</option>
        <option :selected="getField('scrollSpeed') === '1000'" value="1000">Fast</option>
      </select>
    </div>

    <div class="tb-form-group">
      <label class="tb-label">Cycle speed</label>

      <input
        type="number"
        class="tb-input"
        :value="getNiceTime(getField('displayTime'))"
        data-entity="producer-editor-displayTime"
        data-test="display-editor-cycleSpeed"
        @keyup.right.stop
        @keyup.left.stop
        @change="setNiceTime('displayTime', $event.target.value)"
      >

      <span class="help-text">Range: 1 - 100 seconds</span>
    </div>

    <background
      :item="item"
      :theme="theme"
      :editing="editing"
    />

    <div class="tb-form-group" data-entity="producer-editor-toggleKeyColorPicker">
      <label class="tb-label">Chroma key color</label>

      <colorpicker
        :color="getField('keyColor')"
        @change="setField('keyColor', $event)"
      />
    </div>
  </div>
</template>

<script>
import editingMixins from '../../../mixins/editing-mixins';

import Cta from '../shared/Cta.vue';
import Background from '../shared/Background.vue';
import Animation from '../shared/Animation.vue';

export default {
  mixins: [editingMixins],

  components: {
    Cta,
    Background,
    Animation,
  },

  data() {
    return {
      animationOptions: [
        'Slide',
        'Flip',
        'Fade',
      ],
    };
  },

  created() {
    if (!this.item.fields) {
      this.$set(this.item, 'fields', {});
    }
  },
};
</script>
